import { GET_INTERNAL_ASSIGNED_LEADS, GET_INTERNAL_ASSIGNED_LEADS_ERR } from '../../actionTypes/internalDashboardType'
import { getInternalAssignedLeadsApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getInternalAssignedLeads = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getInternalAssignedLeadsApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_INTERNAL_ASSIGNED_LEADS,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_INTERNAL_ASSIGNED_LEADS_ERR,
            payload: error && error.response
        });
    }
}


